import React from 'react';
import TopSlider from './TopSlider';
import FeaturedProducts from './products/FeaturedProducts';
import Search from './common/Search';

const Home = () => {
    return (
        <>
            <TopSlider />
            <FeaturedProducts />
        </>
    );
};

export default Home;
